import React from "react";
import PropTypes from "prop-types";
import { ALL_COLUMNS } from "./ColumnPicker";

const SORTABLE = new Set(["ref_id", "title", "workflow_name", "stage_name", "status", "priority", "created_at", "assignee_name"]);

export default function TableHeader({ visibleCols, sortBy, sortDir, onSort, allSelected, onSelectAll }) {
  const cols = ALL_COLUMNS.filter((c) => visibleCols.includes(c.key));

  return (
    <thead className="table-light sticky-top" style={{ zIndex: 10 }}>
      <tr>
        {/* Checkbox column */}
        <th style={{ width: 36, padding: "8px 12px" }}>
          <input
            type="checkbox"
            className="form-check-input"
            checked={allSelected}
            onChange={e => onSelectAll(e.target.checked)}
            title={allSelected ? "Deselect all" : "Select all"}
          />
        </th>
        {cols.map((col) => {
          const isSorted = sortBy === col.key;
          const canSort  = SORTABLE.has(col.key);
          return (
            <th
              key={col.key}
              className={`text-nowrap user-select-none ${canSort ? "cursor-pointer" : ""}`}
              style={{ fontSize: 12, fontWeight: 600, letterSpacing: "0.03em", padding: "8px 12px" }}
              onClick={canSort ? () => onSort(col.key) : undefined}
            >
              {col.label}
              {isSorted && (
                <i className={`bi ms-1 ${sortDir === "ASC" ? "bi-sort-up" : "bi-sort-down"}`} style={{ fontSize: 11 }} />
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

TableHeader.propTypes = {
  visibleCols:  PropTypes.arrayOf(PropTypes.string).isRequired,
  sortBy:       PropTypes.string,
  sortDir:      PropTypes.string,
  onSort:       PropTypes.func.isRequired,
  allSelected:  PropTypes.bool,
  onSelectAll:  PropTypes.func.isRequired,
};
